import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export interface ItemsContainerProps {
  rows: number;
}

export const pageLink = css`
  text-decoration: none;
`;

export const paginationBreak = css`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  cursor: default;
  padding: 0 4px;
`;

export const paginationBreakLink = css`
  pointer-events: none;
  cursor: default;
  padding: 0 2px;
`;

export const activePageLink = css`
  pointer-events: none;
  cursor: default;
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, auto);
  grid-row-gap: 16px;
  box-sizing: border-box;

  * {
    box-sizing: inherit;
    overflow: hidden;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const HeadingLink = styled.a<{
  isHref: boolean;
}>`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: var(--cxy-color-midnight-blue-600);
  text-decoration: none;

  &:hover {
    text-decoration: ${({ isHref }) => (isHref ? 'underline' : 'none')};
  }
`;

export const Footer = styled.div<{
  isCentered: boolean;
}>`
  display: flex;
  justify-content: ${({ isCentered }) => (isCentered ? 'center' : 'flex-start')};
  align-items: center;
`;

export const ItemsContainer = styled.div<ItemsContainerProps>`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${({ rows }: { rows: number }) => `repeat(${rows}, auto)`};
  grid-row-gap: 8px;
  grid-column-gap: 20px;
`;

export const ArrowLink = styled.a`
  color: var(--cxy-color-interactive-secondary-subtle);
  text-decoration: none;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.14px;

  display: flex;
  align-items: center;
`;
export const LoadMoreButtonLink = styled.button`
  cursor: pointer;
  text-decoration: none;
  border: 1px solid #9caebd;
  font-size: 14px;
  font-style: normal;
  letter-spacing: 0.14px;
  text-transform: uppercase;
  display: inline-block;
  padding: 16px;
  border-radius: 5px;
  font-family: var(--oc-font-family);
  font-weight: 700;
  line-height: 100%;
  text-align: center;
  color: var(--text-color-subtle-blue);

  :hover {
    background-color: #f4f5fa;
  }
`;
